import {
  FETCH_WORKKARD_DETAIL_MASTER_DATA,
  ACTIVITY_LISTING_DATA,
  UPDATE_WORKKARD_FIELD,
  FETCH_WORKKARD_CARRIER,
  FETCH_ACTIVITY_DETAIL_DATA,
  FETCH_ACTIVITY_TEMPLATES_LIST,
  FETCH_ASSOCIATED_WARKKARD_DATA,
  FETCH_ASSOCIATED_WARKKARD_FILTER,
  PANEL_VISIBILITY_DATA_REQUEST,
  GET_ALL_NOTE_TEMPLATES,
  GET_SELECTED_NOTE_TEMPLATE_DATA,
  PUBLISH_NOTE,
  SAVE_DRAFT_NOTE,
  PUBLISH_SAVED_NOTE,
  CHANGE_NOTE_TEMPLATE_TYPE,
  SET_ACTIVITY_ID,
  EDIT_DRAFT_NOTE_REQUEST,
  CLONE_SAVED_NOTE_TO_DRAFT_REQUEST,
  DELETE_SAVED_NOTE_REQUEST,
  CHANGE_NOTE_TYPE,
  CHANGE_NOTE_CREATION_ACTIVITY_TEMPLATE_REQUEST,
  SAVE_AND_UPDATE_FILE_CAPTION,
  FETCH_WORKKARD_LETTER_REQUEST,
  TOGGLE_VIEW,
  FETCH_OPEN_ACTIVITY_DIARIES_REQUEST,
  FETCH_ACTIVITY_NOTIFICATION_REQUEST,
  POST_ACTIVITY_MENU_ACTION_REQUEST,
  SHOW_TOOLTIP,
  HIDE_TOOLTIP,
  CLOSE_ACTIVITY_REQUEST,
  CLEAR_VALIDATION_ERROR_MESSAGE,
  FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST,
  FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST,
  FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST,
  FETCH_CLOSE_WORKKARD_PERMISSION_REQUEST,
  CLOSE_WORKKARD_REQUEST,
  IS_START_TOUR,
  SET_USER_TOUR_STATUS,
  GET_USER_TOUR_STATUS,
  RESOLUTION_BASED_CLASS_REQUEST,
  RESET_WORKKARD_FILES_REQUEST,
  RESET_WORKKARD_LETTERS_REQUEST,
  SORT_COMBINED_VIEW_DATA_REQUEST,
  DISCARD_NOTE_REDIRECT_URL,
  CLOSE_WORKKARD_RESET_STATE,
  CLOSE_ACTIVITY_RESET_STATE,
  RESET_WORKKARD_DETAIL_DATA,
  RESET_PANEL_VISIBILITY,
  IS_SELECT_ALL_LETTER,
  CLEAR_APPLICATON_ERROR,
  FETCH_CONTACT_INSURED_DETAILS_REQUEST,
  RESET_CONTACT_INSURED_DETAILS,
  SAVE_CONTACT_INSURED_DETAILS,
  SAVE_MESSAGE_QUEUE,
  GET_TIMEZONE_BY_ZIP,
  CLEAR_CLOSE_ACTIVITIES,
  GET_SAVED_NOTE_FILTER_DATA,
  UPDATE_USER_CUSTOM_FIELD_DATA, 
  DISCARD_SELECTED_NOTE_TEMPLATE,
  UPDATE_USER_PINNED_FIELDS,
  RESET_USER_CUSTOM_FIELD_DATA,
  GET_WORKKARD_ACTIVITY_NOTE_FILES
} from "../../../containers/WorkkardDetail/actions/actionConstants";
import { SESSIONCONTEXT_DATA } from "../../../common/actionConstants";

export const getWorkkardDetailMasterData = payload => ({
  type: FETCH_WORKKARD_DETAIL_MASTER_DATA,
  payload
});

export const getActivityListByClaim = payload => ({
  type: ACTIVITY_LISTING_DATA,
  payload
});

export const getActivityDetail = payload => ({
  type: FETCH_ACTIVITY_DETAIL_DATA,
  payload
});

export const getActivityTemplatesList = payload => ({
  type: FETCH_ACTIVITY_TEMPLATES_LIST,
  payload
});

export const getAssociatedWorkkardData = payload => ({
  type: FETCH_ASSOCIATED_WARKKARD_DATA,
  payload
});

export const fetchFilter = payload => ({
  type: FETCH_ASSOCIATED_WARKKARD_FILTER,
  payload
});

export const setPanelVisibility = payload => ({
  type: PANEL_VISIBILITY_DATA_REQUEST,
  payload
});

export const updateWorkkardField = payload => ({
  type: UPDATE_WORKKARD_FIELD,
  payload
});

export const fetchWorkkardCarrier = payload => ({
  type: FETCH_WORKKARD_CARRIER,
  payload
});

export const getAllNoteTemplates = payload => ({
  type: GET_ALL_NOTE_TEMPLATES,
  payload
});

export const getSelectedNoteTemplateData = payload => ({
  type: GET_SELECTED_NOTE_TEMPLATE_DATA,
  payload
});

export const discardSelectedNoteTemplate = payload => ({
  type: DISCARD_SELECTED_NOTE_TEMPLATE,
  payload
});

export const publishNote = payload => ({
  type: PUBLISH_NOTE,
  payload
});

export const getWorkkardActNoteFiles = payload => ({
  type: GET_WORKKARD_ACTIVITY_NOTE_FILES,
  payload
});

export const publishSavedNote = payload => ({
  type: PUBLISH_SAVED_NOTE,
  payload
});

export const saveDraftNote = payload => ({
  type: SAVE_DRAFT_NOTE,
  payload
});

export const setActivityId = payload =>({
  type : SET_ACTIVITY_ID,
  payload
});

export const changeNoteModuleType = payload =>({
  type: CHANGE_NOTE_TEMPLATE_TYPE,
  payload
});

export const editDraftNote = payload => ({
  type: EDIT_DRAFT_NOTE_REQUEST,
  payload
});

export const cloneSavedNoteToDraft = payload => ({
  type: CLONE_SAVED_NOTE_TO_DRAFT_REQUEST,
  payload
});

export const deleteSavedNote = payload => ({
  type: DELETE_SAVED_NOTE_REQUEST,
  payload
});

export const changeNoteType = payload => ({
  type: CHANGE_NOTE_TYPE,
  payload
});

export const changeNoteCreationActivityTemplate = payload => ({
  type: CHANGE_NOTE_CREATION_ACTIVITY_TEMPLATE_REQUEST,
  payload
});

export const toggleView =payload=>({
  type:TOGGLE_VIEW,
  payload
});

export const getActivityOpenDiaries = (payload) => ({
  type: FETCH_OPEN_ACTIVITY_DIARIES_REQUEST,
  payload
});

export const saveAndUpdateFileCaption = payload => ({
  type: SAVE_AND_UPDATE_FILE_CAPTION,
  payload
});

export const fetchWorkkardLettersData = payload => ({
  type: FETCH_WORKKARD_LETTER_REQUEST,
  payload
});

export const isSelectAllLetter = payload => ({
  type: IS_SELECT_ALL_LETTER,
  payload
});

export const resetAttachedWorkkardFiles = payload => ({
  type: RESET_WORKKARD_FILES_REQUEST,
  payload
});

export const resetAttachedWorkkardLetters = payload => ({
  type: RESET_WORKKARD_LETTERS_REQUEST,
  payload
});

export const getActivityNotifications = (payload) => ({
  type: FETCH_ACTIVITY_NOTIFICATION_REQUEST,
  payload
});

export const postActivityMenuActions = (payload) => ({
  type: POST_ACTIVITY_MENU_ACTION_REQUEST,
  payload
});

export const showTooltip = (payload) => ({
  type: SHOW_TOOLTIP,
  payload
});

export const hideTooltip = () => ({
  type: HIDE_TOOLTIP
});

export const closeActivityFromWeb = (payload) => ({
  type: CLOSE_ACTIVITY_REQUEST,
  payload
});

export const clearErrorValidationMessage = () => ({
  type: CLEAR_VALIDATION_ERROR_MESSAGE
});

export const getCloseWorkkardOpenActivities = (payload) => ({
  type: FETCH_CLOSE_WORKKARD_OPEN_ACTIVITY_REQUEST,
  payload
});

export const getCloseWorkkardOpenDiaries = (payload) => ({
  type: FETCH_CLOSE_WORKKARD_OPEN_DIARIES_REQUEST,
  payload
});

export const getCloseWorkkardOpenNotifications = (payload) => ({
  type: FETCH_CLOSE_WORKKARD_NOTIFICATION_REQUEST,
  payload
});

export const getPermissionsForCloseWorkkard = (payload) => ({
  type: FETCH_CLOSE_WORKKARD_PERMISSION_REQUEST,
  payload
});

export const closeWorkkardPostAction = (payload) => ({
  type: CLOSE_WORKKARD_REQUEST,
  payload
});

export const startTourAction = (payload) => ({
  type: IS_START_TOUR,
  payload
});

export const setUserTourStatusAction = (payload) => ({
  type: SET_USER_TOUR_STATUS,
  payload
});
export const getUserTourStatusAction = () => ({
  type: GET_USER_TOUR_STATUS
});

export const resolutionBasedClass = (payload) => ({
  type: RESOLUTION_BASED_CLASS_REQUEST,
  payload
});

export const sortCombinedView =(payload) =>({
  type:SORT_COMBINED_VIEW_DATA_REQUEST,
  payload
});

export const hidePopupToast = (payload) => ({
  type: SESSIONCONTEXT_DATA,
  payload
});

export const discardNoteRedirectUrl = (payload) => ({
  type: DISCARD_NOTE_REDIRECT_URL,
  payload
});

export const resetCloseWorkkardState = ()=>({
  type:CLOSE_WORKKARD_RESET_STATE
})

export const resetCloseActivityState = ()=>({
  type:CLOSE_ACTIVITY_RESET_STATE
})

export const resetWorkkardDetail = ()=>({
  type:RESET_WORKKARD_DETAIL_DATA
})

export const resetpanelvisibility = () => ({
  type: RESET_PANEL_VISIBILITY
})

export const resetAppError = () => ({
  type: CLEAR_APPLICATON_ERROR
})

export const fetchContactInsuredDetails = (payload) => ({
  type: FETCH_CONTACT_INSURED_DETAILS_REQUEST,
  payload
})

export const resetContactInsuredDetails = () => ({
  type: RESET_CONTACT_INSURED_DETAILS,
})

export const saveContactInsuredDetails = (payload) => ({
  type: SAVE_CONTACT_INSURED_DETAILS,
  payload
});

export const saveMessageQueue = (payload) => ({
  type: SAVE_MESSAGE_QUEUE,
  payload
})

export const getTimezoneByZip =(payload)=>({
  type:GET_TIMEZONE_BY_ZIP,
  payload
})

export const clearCloseActivities = (payload) => ({
  type: CLEAR_CLOSE_ACTIVITIES,
  payload
});

export const getsavednotefilters = (payload) => ({
  type: GET_SAVED_NOTE_FILTER_DATA,
  payload,
});

export const updateUserCustomFieldData = payload => ({
  type: UPDATE_USER_CUSTOM_FIELD_DATA,
  payload
});

export const resetUserCFData = payload => ({
  type: RESET_USER_CUSTOM_FIELD_DATA,
  payload
});

export const updateUserPinnedFields = payload => ({
  type: UPDATE_USER_PINNED_FIELDS,
  payload
});